var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.06348V5.39681M6.66667 2.06348V5.39681M2.5 8.73014H17.5M4.16667 3.73014H15.8333C16.7538 3.73014 17.5 4.47634 17.5 5.39681V17.0635C17.5 17.984 16.7538 18.7301 15.8333 18.7301H4.16667C3.24619 18.7301 2.5 17.984 2.5 17.0635V5.39681C2.5 4.47634 3.24619 3.73014 4.16667 3.73014Z",
    stroke: "#8D9196",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.53a50ab7b63c2052655cd05bc44a8f8a.svg";
export { ForwardRef as ReactComponent };